<script>
import Layout from "@/router/layouts/auth";
import Languages from "@/components/widgets/languages";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";
import TripteevPlanCard from "@/components/widgets/tripteev-plan-card";
import { api } from "@/state/services";

// Confirmação da cobrança (adesão ou mensalidade) antes de gerar a fatura
export default {
  locales: {
    pt: {
      'Back': 'Voltar',
      'We apologize, we are unable to retrieve the information at this time.': 'Pedimos desculpas, não podemos recuperar as informações neste momento.',
      'Try again': 'Tentar novamente',
      'Confirm your membership': 'Confirme sua adesão',
      'Confirm your monthly fee': 'Confirme sua mensalidade',
      'Review the details below. On the next screen you choose how to pay.': 'Revise os detalhes abaixo. Na próxima tela você escolhe como pagar.',
      'Summary': 'Resumo',
      'Charge': 'Cobrança',
      'Membership': 'Adesão',
      'Monthly fee': 'Mensalidade',
      'Plan': 'Plano',
      'Access period': 'Período de acesso',
      'to': 'a',
      'Payment': 'Pagamento',
      'PIX, card or balance': 'PIX, cartão ou saldo',
      'Total': 'Total',
      'The period is confirmed on the payment date: if you pay after the due date, the 30 days start on the payment date.': 'O período é confirmado na data do pagamento: se pagar depois do vencimento, os 30 dias começam na data do pagamento.',
      'Generate invoice and pay': 'Gerar fatura e pagar',
      'There is no Tripteev plan available for you.': 'Não há plano do Tripteev disponível para você.',
      'Unable to create the invoice, please try again.': 'Não foi possível gerar a fatura, tente novamente.',
      'Your payment has already been identified and is being activated. Please wait a moment.': 'Seu pagamento já foi identificado e está sendo ativado. Aguarde alguns instantes.',
      'Your current invoice has a partial payment. Complete the payment to continue.': 'Sua fatura atual tem pagamento parcial. Complete o pagamento para continuar.',
      'You have already paid the next monthly fee in advance.': 'Você já antecipou a próxima mensalidade.',
      'Confirm to generate the invoice.': 'Confirme para gerar a fatura.',
      'Back to Tripteev': 'Voltar ao Tripteev',
      'Combo': 'Combo',
    },
    es: {
      'Back': 'Volver',
      'We apologize, we are unable to retrieve the information at this time.': 'Lo sentimos, no podemos recuperar la información en este momento.',
      'Try again': 'Intentar de nuevo',
      'Confirm your membership': 'Confirma tu adhesión',
      'Confirm your monthly fee': 'Confirma tu mensualidad',
      'Review the details below. On the next screen you choose how to pay.': 'Revisa los detalles a continuación. En la siguiente pantalla eliges cómo pagar.',
      'Summary': 'Resumen',
      'Charge': 'Cobro',
      'Membership': 'Adhesión',
      'Monthly fee': 'Mensualidad',
      'Plan': 'Plan',
      'Access period': 'Período de acceso',
      'to': 'al',
      'Payment': 'Pago',
      'PIX, card or balance': 'PIX, tarjeta o saldo',
      'Total': 'Total',
      'The period is confirmed on the payment date: if you pay after the due date, the 30 days start on the payment date.': 'El período se confirma en la fecha de pago: si pagas después del vencimiento, los 30 días comienzan en la fecha de pago.',
      'Generate invoice and pay': 'Generar factura y pagar',
      'There is no Tripteev plan available for you.': 'No hay un plan de Tripteev disponible para ti.',
      'Unable to create the invoice, please try again.': 'No fue posible generar la factura, inténtalo de nuevo.',
      'Your payment has already been identified and is being activated. Please wait a moment.': 'Tu pago ya fue identificado y se está activando. Espera unos instantes.',
      'Your current invoice has a partial payment. Complete the payment to continue.': 'Tu factura actual tiene un pago parcial. Completa el pago para continuar.',
      'You have already paid the next monthly fee in advance.': 'Ya adelantaste la próxima mensualidad.',
      'Confirm to generate the invoice.': 'Confirma para generar la factura.',
      'Back to Tripteev': 'Volver a Tripteev',
      'Combo': 'Combo',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemUserMenu,
    TripteevPlanCard,
  },
  data() {
    return {
      logo: require("@/assets/images/brands/tripteev.svg"),
      loading: true,
      errored: false,
      submitting: false,

      next: null,
    };
  },
  computed: {
    title() {
      return this.next && this.next.type == "adhesion" ? this.t("Confirm your membership") : this.t("Confirm your monthly fee");
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.errored = false;

      api
        .get("tripteev")
        .then((response) => {
          if (response.data.status == "success") {
            // Fatura em aberto: segue direto para o pagamento
            if (response.data.pending && response.data.pending.status == "pending") {
              this.$router.replace("/tripteev/order/" + response.data.pending.order.id);
              return;
            }

            // Nada a cobrar nesta situação
            if (!response.data.next) {
              this.$router.replace("/tripteev");
              return;
            }

            this.next = response.data.next;
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirm() {
      this.submitting = true;

      api
        .post("tripteev", { confirm: "yes" })
        .then((response) => {
          if (response.data.status == "success") {
            this.$router.push("/tripteev/order/" + response.data.order.id);
          } else {
            this.$toast.error(this.t(response.data.message));
          }
        })
        .catch(() => {
          this.$toast.error(this.t("Unable to create the invoice, please try again."));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <router-link to="/tripteev" class="ecosystem-back">
          <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> {{ t('Back to Tripteev') }}
        </router-link>
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <div v-if="loading" class="text-center py-5">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
        <div v-else-if="errored" class="text-center py-5">
          <p>{{ t('We apologize, we are unable to retrieve the information at this time.') }}</p>
          <button class="btn btn-default" v-on:click="load()">{{ t('Try again') }}</button>
        </div>
        <div v-else-if="next" class="tripteev">
          <div class="tripteev-intro">
            <img :src="logo" alt="Tripteev" class="tripteev-logo" />
            <h1 class="tripteev-title">{{ title }}</h1>
            <p class="tripteev-subtitle">{{ t('Review the details below. On the next screen you choose how to pay.') }}</p>
          </div>

          <div class="tripteev-confirm">
            <TripteevPlanCard :plan="next" :recommended="false" />

            <div class="tripteev-box tripteev-summary">
              <h5 class="mb-3">{{ t('Summary') }}</h5>
              <dl>
                <div>
                  <dt>{{ t('Charge') }}</dt>
                  <dd>{{ next.type == 'adhesion' ? t('Membership') : t('Monthly fee') }}</dd>
                </div>
                <div v-if="next.combo">
                  <dt>{{ t('Combo') }}</dt>
                  <dd>{{ next.combo }}</dd>
                </div>
                <div>
                  <dt>{{ t('Access period') }}</dt>
                  <dd>{{ next.date_start }} {{ t('to') }} {{ next.date_end }}</dd>
                </div>
                <div>
                  <dt>{{ t('Payment') }}</dt>
                  <dd>{{ t('PIX, card or balance') }}</dd>
                </div>
                <div class="is-total">
                  <dt>{{ t('Total') }}</dt>
                  <dd>{{ next.value | currency }}</dd>
                </div>
              </dl>

              <div class="tripteev-note">
                <i class="bx bx-info-circle" aria-hidden="true"></i>
                <span>{{ t('The period is confirmed on the payment date: if you pay after the due date, the 30 days start on the payment date.') }}</span>
              </div>

              <button class="btn btn-default btn-lg btn-block text-uppercase" :disabled="submitting" v-on:click="confirm()">
                {{ t('Generate invoice and pay') }}
                <b-spinner v-if="submitting" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </button>
              <router-link to="/tripteev" class="btn btn-outline-default btn-lg btn-block text-uppercase mt-2">{{ t('Back') }}</router-link>
            </div>
          </div>
        </div>
      </main>
    </div>
  </Layout>
</template>
